import React, { useCallback, useRef, useState, useMemo } from "react";
import { connect } from "react-redux";
import { GetFormatedDateWithTime } from '../../../../../common/Utils'
import RenderSelectBoxCell from "../../../../../common/RenderCell";
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    FilterPanel,
    Paging,
    Editing,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    Selection,
    Toolbar,
    Item,
    RequiredRule,
    StateStoring

} from "devextreme-react/data-grid";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import "jspdf-autotable";
import { Button, SelectBox, TextArea } from 'devextreme-react';
import axios from "axios";
import { confirm } from 'devextreme/ui/dialog';
import data from "../../../../../assets/apiRoutes.json";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import { GridLayout } from "../../../../../common/GridLayout";
import { Options } from "../../../../../enum/Enum";
import { checkLocationClassOnPick } from "./locationClassCheck";
let availableFlag = "";
function PrimaryTab(props) {
    const gridKey = "8EC944A5-F250-4A18-B38C-0E51961EDB41";
    const allowedPageSizes = [10, 20, 100, 500, "all"];
    const [currentLayout, setCurrentLayout] = useState("Default");
    const [reasonCodeDisabled, setReasonCodeDisabled] = useState(false);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    var url = "im/Transactionlocation/GetTransactionlocationDetails";
    var updateUrl = "im/Transactionlocation/UpdateTransactionlocation";
    var insertUrl = "im/Transactionlocation/AddTransactionlocationDetails";
    var deleteUrl = "im/Transactionlocation/DeleteTransactionlocation";
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const dataSource = useMemo(() => createStore({
        key: 'rowid',
        loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
        insertUrl: `${window._env_.REACT_APP_APIS}/${insertUrl}`,
        updateUrl: `${window._env_.REACT_APP_APIS}/${updateUrl}`,
        // deleteUrl: `${window._env_.REACT_APP_APIS}/${deleteUrl}`,
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                Key: props.sourceId,
            };
        },
        onUpdated: function (e) {
            props.RefereshGrid();
        },
        onInserted: function (e) {
            props.RefereshGrid();
        }
    }), [props.sourceId]);

    var accessToken = props.oidc.user.access_token;

    const onContentReady = (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            var selection = e.component.getSelectedRowKeys();
            if (selection.length == 0) {
                e.component.selectRowsByIndexes([0]);
            }
        }
    };
    const onEditingStart = (e) => {
        if (e.key != null && e.key != undefined && !props.dataGrid.current.instance().isRowSelected(e.key)) {
            props.dataGrid.current.instance().selectRows([e.key], false);
        }

    };
    const handleCellValueChanged = (data) => {
        setSelectedItemKeys(data.selectedRowKeys);
    }

    const deleteRecords = useCallback(() => {
        var deleteUrl = "im/Transactionlocation/DeleteTransactionlocation";
        let result = confirm("<i>Are your sure you want to delete selected records?</i>", "Delete");
        result.then((dialogResult) => {
            if (dialogResult) {
                props.dataGrid.current.instance().beginCustomLoading("Deleting");
                axios.post(
                    `${window._env_.REACT_APP_APIS}/${deleteUrl}`,
                    selectedItemKeys,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            access_token: accessToken,
                        },
                    }
                )
                    .then((res) => {
                        props.dataGrid.current.instance().endCustomLoading();
                        props.dataGrid.current.instance().refresh();
                        props.UpdateTotalAmount();
                    })
                    .catch((err) => {
                        props.dataGrid.current.instance().endCustomLoading();
                    });
            }
        });
    }, [selectedItemKeys]);
    const renderCell = (cellElement) => {
        const items = [{ "id": "Y", "name": "Yes" },
        { "id": "N", "name": "No" },
        ];
        const currentValue = cellElement.row.data.availableflag;
        return (
            <SelectBox
                dataSource={items}
                valueExpr="id"
                displayExpr="name"
                defaultValue={currentValue}
                acceptCustomValue={true}
                searchEnabled={false}
                searchMode="contains"
                showClearButton={false}
                searchExpr="name"
                onValueChanged={(e) => {
                    const selectedText = e.component.option('displayValue');
                    availableFlag = e.value;
                    cellElement.setValue(selectedText);
                }}
            />
        );
    }
    async function setStateValue3(rowData, value) {
        try {
            if (availableFlag == "Y") {
                rowData.availablereasoncode = "";
                setReasonCodeDisabled(true);
            }
            else {
                setReasonCodeDisabled(false);
            }
            rowData.availableflag = availableFlag;
            rowData.availableflagDiscription = value;

        } catch (error) {
            console.error("Failed to fetch item data:", error);
        }
    }

    const renderCode1Cell = (cellElement) => {
        return (
            <TextArea
                onValueChanged={async (e) => {
                    cellElement.setValue(e.value);
                }}
                label="."
                labelMode='static'
                stylingMode='outlined'

            >
            </TextArea>
        );
    }
    const onInitNewRow = (e) => {
        if (!e.data.availableflag) {
            e.data.availableflag = "Y";
            e.data.availableflagDiscription = "Yes";
        }
        if (props.profile?.RWarehouse) {
            // Programmatically call setCellValue for warehousecode column
            const grid = e.component;
            if (grid) {
                const columns = grid.getVisibleColumns();
                const warehouseCol = columns.find(col => col.dataField === 'warehousecode');
                if (warehouseCol && typeof warehouseCol.setCellValue === 'function') {
                    warehouseCol.setCellValue(e.data, { value: props.profile.RWarehouse }); // Set text to warehouse name if available
                }
            }
        }
    };
    const onRowInserted = (e) => {
        props.dataGrid.current.instance().selectRows([e.key], true);
        e.component.columnOption('keySequence', {
            sortOrder: 'asc',
            sortIndex: 0
        });
    };
    return (
        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
            id="gridContainer"
            dataSource={dataSource}
            ref={props.dataGrid}
            selectedRowKeys={selectedItemKeys}
            showBorders={true}
            rowAlternationEnabled={true}
            allowColumnReordering={true}
            allowColumnResizing={true}
            columnAutoWidth={true}
            onSelectionChanged={handleCellValueChanged}
            onInitNewRow={onInitNewRow}
            height="100%"
            onEditingStart={onEditingStart}
            onContentReady={onContentReady}
        >
            <ColumnChooser
                enabled={true}
                title="Choose Column"
                width={290}
                height={290}
                sortOrder="asc"
            >
                <ColumnChooserSearch
                    enabled={true}
                    editorOptions={{ placeholder: 'Search column' }} />
            </ColumnChooser>
            <StateStoring
                enabled={true}
                type="custom"
                customLoad={loadState}
                storageKey={gridKey}
                customSave={saveState}
            />
            <Scrolling mode="standard" />
            <Selection mode="single" />
            <Export enabled={true} allowExportSelectedData={true} />
            <Editing
                mode="cell"
                refreshMode="repaint"
                allowUpdating={!props.isCommittedTransaction}
                allowAdding={!props.isCommittedTransaction}
            />

            <FilterRow visible={true} />
            <Column dataField="keySequence" caption='Key Sequence' visible={false} allowSorting={false} showInColumnChooser={false} />
            <Column dataField="rowid" caption='rowid' visible={false} allowSorting={false} showInColumnChooser={false}   >
            </Column>
            <Column dataField="warehousecode" caption="Warehouse" allowSorting={false}
                editCellRender={(cellElement) =>
                    RenderSelectBoxCell({
                        loadUrl: `${window._env_.REACT_APP_APIS}/id/Lookup/GetWarehouses`,
                        key: "id",
                        displayExpr: "name",
                        valueExpr: "id",
                        accessToken: accessToken,
                        defaultValue: cellElement.data.warehouseId,
                        sort: [{ selector: "name", desc: false }],
                        onValueChangeCallback: (value, text, additionalData) => {
                            cellElement.setValue(({ value, text, additionalData }));
                        },
                    })
                }
                setCellValue={(rowData, newValue) => {
                    rowData.warehouseId = newValue.value;
                    rowData.warehousecode = newValue.text;
                }}
            >
            </Column>
            <Column dataField="locationcode" caption="Location" allowSorting={false}
                editCellRender={(cellElement) =>
                    RenderSelectBoxCell({
                        loadUrl: `${window._env_.REACT_APP_APIS}/im/Lookup/GetLocations`,
                        key: "id",
                        loadParams:
                        {
                            warehouseRowId: cellElement.data.warehouseId
                        },
                        displayExpr: "name",
                        valueExpr: "id",
                        accessToken: accessToken,
                        defaultValue: cellElement.data.locationId,
                        sort: [{ selector: "name", desc: false }],
                        onValueChangeCallback: async (value, text, additionalData) => {
                            // Reserve Location class rule, shared with the manual selection screens so it
                            // cannot drift. Checked BEFORE the value is applied: LOCATIONBYCLASS 'Y'
                            // refuses the location outright and 'W' refuses it only if the user declines,
                            // the same outcome the selection screens produce by un-ticking the row.
                            if (additionalData) {
                                const accepted = await checkLocationClassOnPick({
                                    itemClassCode: props.selectedDetails?.itemClasscode,
                                    itemSubClassCode: props.selectedDetails?.itemSubclasscode,
                                    locationClassCode: additionalData.classCode,
                                    locationSubClassCode: additionalData.subClassCode,
                                    locationByClass: props.profile?.Locationbyclass,
                                    transactionType: props.transactionType,
                                });
                                if (!accepted) return;
                            }
                            cellElement.setValue({ value, text, additionalData });
                        },
                    })
                }
                setCellValue={(rowData, newValue) => {
                    rowData.locationId = newValue.value;
                    rowData.locationcode = newValue.text;
                }}
            >
                {props.profile?.Allowblanklocations !== 'Y' && (<RequiredRule message="A valid Location Must be Assigned" />)}
            </Column>
            <Column dataField={props?.transactionType === 'S' ? "outShipped" : "inReceiving"} caption="Quantity" dataType="number" format="#,##0.00" allowSorting={false} />
            <Column dataField="availableflagDiscription" caption='Available' editCellRender={renderCell} setCellValue={setStateValue3} allowSorting={false}>
            </Column>
            <Column
                dataField="availablereasoncode"
                caption="Reason"
                dataType="string"
                allowSorting={false}
                editCellRender={cellElement => {
                    const rowDisabled = cellElement.row.data.availableflag === "Y";
                    return RenderSelectBoxCell({
                        loadUrl: `${window._env_.REACT_APP_APIS}/wm/Lookup/GetCodes`,
                        loadParams: { codeType: "02" },
                        key: "name",
                        displayExpr: "name",
                        valueExpr: "name",
                        accessToken,
                        disabled: rowDisabled,
                        sort: [{ selector: "name", desc: false }],
                        defaultValue: cellElement.data.availablereasoncode,
                        onValueChangeCallback: (value, text) => {
                            cellElement.setValue({ value, text });
                        },
                    });
                }}
                setCellValue={(rowData, newValue) => {
                    rowData.availablereasoncode = newValue.text;
                }}
            />
            <Column dataField="comment" visible={false} editCellRender={renderCode1Cell}
                setCellValue={(rowData, newValue) => {
                    rowData.comment = newValue;
                }} caption='Comment' >
            </Column>
            {props.profile?.Translocweight === Options.Yes && (<Column dataField="netweight" caption="Net Wt" dataType="number" format="#,##0.00" />)}
            {props.profile?.Translocweight === Options.Yes && (<Column dataField="grossweight" caption="Gross Wt" dataType="number" format="#,##0.00" />)}
            <Toolbar>
                <Item
                    name="addRowButton"
                />
                <Item location="after">
                    <Button
                        onClick={deleteRecords}
                        icon="trash"
                        disabled={!selectedItemKeys.length || props.isCommittedTransaction == true}
                    />
                </Item>
                <Item location="after">
                    <GridLayoutManager gridKey={gridKey} dataGrid={props.dataGrid} setCurrentLayout={setCurrentLayout} />
                </Item>
                <Item name="exportButton" />
                <Item name="columnChooserButton" />
            </Toolbar>
        </DataGrid>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(PrimaryTab);
